// extracted by mini-css-extract-plugin
export default {"toolbar":"PageToolbar_toolbar__DA8Ny","left":"PageToolbar_left__Pfrgi","right":"PageToolbar_right__Kgwi5"};